import { CancelFunc, emptyCancel } from 'lib/cancel'
import { Status } from 'lib/rpc'
import { ActionStatus, expandValue, unaryInvoke } from 'lib/rpcts'
import { App } from 'pbts/c1/api/app/v1/app'
import { AppUser, AppUserServiceGetRequest, AppUserServiceGetResponse, AppUserView } from 'pbts/c1/api/app/v1/app_user'
import { AppUserServiceClient } from 'pbts/c1/api/app/v1/app_user.client'
import { User } from 'pbts/c1/api/user/v1/user'
import { Any } from 'pbts/google/protobuf/any'
import { Timestamp } from 'pbts/google/protobuf/timestamp'
import { Dispatch } from 'react'

export enum AppUserAction {
    get = 'AppUsersAction.get',
}

export type GetAction = {
    type: AppUserAction.get
    payload: ActionStatus<AppUserValue>
}

export type AppUserActions = GetAction

export interface AppUserValue extends AppUser {
    identityUser?: User
    app?: App
    lastUsedAt?: Timestamp
    alertCount?: number
}

export interface AppUserViewResponse {
    appUserView?: AppUserView
    expanded: Any[]
}

export const expandAppUserPayload = (payload: ActionStatus<AppUserViewResponse>): ActionStatus<AppUserValue> => {
    switch (payload.status) {
        case Status.OK:
            return {
                status: Status.OK,
                item: expandAppUserView(payload.item.appUserView, payload.item.expanded),
            }
        default:
            return payload
    }
}

export const expandAppUserView = (msg: AppUserView | undefined, values: Any[]): AppUserValue => {
    const u: AppUserValue = AppUser.create(msg?.appUser ?? {})
    u.identityUser = expandValue<User>(msg?.identityUserPath || '', User, values)
    u.app = expandValue<App>(msg?.appPath || '', App, values)
    u.lastUsedAt = expandValue<Timestamp>(msg?.lastUsagePath || '', Timestamp, values)
    return u
}

export const getAppUser = (
    dispatch: Dispatch<GetAction>,
    userId: string,
    appId: string,
    client?: AppUserServiceClient,
): CancelFunc => {
    if (!client) {
        return emptyCancel
    }

    return unaryInvoke<AppUserServiceGetRequest, AppUserServiceGetResponse>(
        AppUserServiceGetRequest.create({
            id: userId,
            appId,
            expandMask: { paths: ['*'] },
        }),
        client.get.bind(client),
        (payload) => {
            dispatch({
                type: AppUserAction.get,
                payload: expandAppUserPayload(payload),
            })
        },
    )
}
